export const CountryIds = {
  NO_COUNTRY: 0,
  USA: 1,
  CANADA: 2,
  PR: 3,
  AND: 4,
  BLR: 9,
  BEL: 10,
  BRZ: 11,
  COLOMBIA: 15,
  CRO: 17,
  CUBA: 18,
  CURACAO: 19,
  CZE: 20,
  DEN: 21,
  DR: 22,
  FRA: 25,
  GER: 26,
  GRC: 27,
  GUAM: 29,
  ISR: 35,
  ITA: 36,
  JAPAN: 38,
  LIT: 39,
  MEXICO: 41,
  NTH: 43,
  PANAMA: 48,
  RUS: 51,
  POR: 55,
  SLO: 56,
  SPN: 59,
  SWE: 61,
  SWZ: 62,
  UK: 65,
  USVI: 66,
  VEN: 67,
  AST: 69,
  BUL: 72,
  HUN: 74,
  POL: 75,
  SMR: 77,
  SVN: 85,
  NOR: 87,
  UKR: 88,
  SRB: 89,
  AB: 102,
  ISL: 106,
  TR: 107,
  FIN: 109,
  IRL: 117,
};

export const TppCountries = [CountryIds.COLOMBIA, CountryIds.DR, CountryIds.PANAMA, CountryIds.VEN];

export const ShowcaseCountries = [
  CountryIds.BRZ,
  CountryIds.CUBA,
  CountryIds.CURACAO,
  CountryIds.SPN,
  CountryIds.ITA,
  CountryIds.SLO,
  CountryIds.NTH,
  CountryIds.CZE,
  CountryIds.FRA,
  CountryIds.GER,
  CountryIds.ISR,
  CountryIds.BUL,
  CountryIds.AST,
  CountryIds.SWZ,
  CountryIds.BEL,
  CountryIds.UK,
  CountryIds.VEN,
];

export const EuropeanShowcaseCountries = [
  CountryIds.AB,
  CountryIds.AND,
  CountryIds.AST,
  CountryIds.BLR,
  CountryIds.BEL,
  CountryIds.BUL,
  CountryIds.CRO,
  CountryIds.DEN,
  CountryIds.FIN,
  CountryIds.FRA,
  CountryIds.GER,
  CountryIds.GRC,
  CountryIds.HUN,
  CountryIds.ISL,
  CountryIds.IRL,
  CountryIds.ISR,
  CountryIds.ITA,
  CountryIds.LIT,
  CountryIds.NOR,
  CountryIds.POL,
  CountryIds.POR,
  CountryIds.RUS,
  CountryIds.SMR,
  CountryIds.SRB,
  CountryIds.SLO,
  CountryIds.SVN,
  CountryIds.SPN,
  CountryIds.SWE,
  CountryIds.SWZ,
  CountryIds.TR,
  CountryIds.UKR,
  CountryIds.UK,
];
